import React from 'react';
import { Block } from "@randajan/jet-react/dom/block";

import "./LegalSlide.scss";
import { Locale } from '../../../../assets/Locale';
import { Button } from '@mui/material';
import { useWizard } from '../../../../elements/Wizard/Wizard';
import { Link } from '@randajan/jet-react/dom/link';
import { Article } from '../../../../elements/Article/Article';
import { LinkBlank } from '../../../../elements/LinkBlank/LinkBlank';


export const LegalSlide = (props)=>{
    const { legal, signedAt } = props;
    const { title, desc, signMsg, signBtn, urlMd, url } = (legal || {});
    const say = Locale.use();
    const wiz = useWizard();
    
    return (
        <Block level={0} className="LegalSlide" caption={title}>
            <div className="legalDesc">{desc}</div>
            <div className="preview">
                <Article src={`${urlMd}?hrefsFormat=html`} linkBlank/>
            </div>
            <div className="legalLink"><LinkBlank to={url}>{say("legalUrlLabel")}</LinkBlank></div>
            <div className="signMsg">{!signedAt && signMsg && say("legalBtnPressMsg").replace("$", signBtn) + " " + signMsg}</div>
            <div className="reason">{signedAt && "Nová verze"}</div>
            <div className="signedAt">{signedAt && say.date(signedAt)}</div>
            <div className="controls">
                <Button className="BlimpMuiPanel-action" onClick={wiz.cancel} type="button" variant="outlined">{say("legalDismissBtn")}</Button>
                <Button className="BlimpMuiPanel-actionPrimary" onClick={wiz.next} type="button" variant="contained">{signBtn}</Button>
            </div>
        </Block>
    )
}

